import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Poll from './polls/Poll';
import AddPoll from './polls/AddPoll';
import { getSocket } from '../../../socket';

export default function PollCard({ agenda, meeting, onCountChange }) {
  const [polls, setPolls] = useState([]); // State to store polls
  const params = useParams();
  const effectiveMeetingId = String(params.meetingId || meeting?.meetingDetails?.id || meeting?._id || '').trim();
  const url = process.env.REACT_APP_URL;
  const { user: authUser } = useSelector((state) => state.auth);
  const specialAssignments = meeting?.meetingDetails?.specialAssignments || meeting?.specialAssignments || {}
  const authIdentityIds = [
    authUser?.user?.localUserId,
    authUser?.user?._id,
    authUser?.user?.id,
    authUser?.user?.tmAuthUserId,
  ]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
  const isPollManager = Boolean(
    authIdentityIds.length
    && authIdentityIds.includes(String(specialAssignments.pollManager || '').trim())
  );
  const isTimerManager = Boolean(
    authIdentityIds.length
    && authIdentityIds.includes(String(specialAssignments.timerManager || '').trim())
  );
  const isOfficer = String(authUser?.user?.acl || authUser?.acl || '').trim().toLowerCase() === 'officer';
  const canManagePolls = isPollManager || isTimerManager || isOfficer;
  const attendeeCount = Array.isArray(meeting?.meetingDetails?.attendance)
    ? meeting.meetingDetails.attendance.length
    : 0;

  const getPolls = useCallback(async () => {
    if (!effectiveMeetingId) return;
    try {
      const response = await fetch(`${url}/polls/${effectiveMeetingId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(authUser?.token ? { Authorization: `Bearer ${authUser.token}` } : {}),
        },
      });

      if (response.ok) {
        const data = await response.json();
        setPolls((Array.isArray(data) ? data : []).map((poll) => poll._id)); // Store poll IDs
      } else {
        console.error('Failed to fetch polls:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching polls:', error);
    }
  }, [url, effectiveMeetingId, authUser?.token]);

  useEffect(() => {
    getPolls();
  }, [getPolls]);

  useEffect(() => {
    if (!effectiveMeetingId) return undefined;

    const socket = getSocket();
    socket.emit('meeting:join', effectiveMeetingId);

    const handlePollStatusChanged = (payload) => {
      if (payload && String(payload.meetingId || '') !== effectiveMeetingId) return;
      getPolls();
    };

    socket.on('poll:status-changed', handlePollStatusChanged);

    return () => {
      socket.off('poll:status-changed', handlePollStatusChanged);
    };
  }, [effectiveMeetingId, getPolls]);

  useEffect(() => {
    if (typeof onCountChange === 'function') {
      onCountChange(polls.length);
    }
  }, [onCountChange, polls.length]);


  return (
    <div className='polls-admin-panel'>
      <Row>
        <Col>
          {canManagePolls &&
            <AddPoll agenda={agenda} meetingId={effectiveMeetingId} getPolls={getPolls} />
          }
          {polls.length > 0 ? (
            polls.map((pollId) => (
              <Poll key={pollId} pollId={pollId} getPolls={getPolls} attendeeCount={attendeeCount} isPollManager={canManagePolls} />
            ))
          ) : (
            <p className='mb-0 profile-overview-empty-message'>No polls available for this meeting.</p>
          )}
        </Col>
      </Row>
    </div>
  );
}